import styled from 'styled-components';

const SearchTreeStyled = styled.div`
  width: 296px;
  padding: 24px;
  padding-top: 15px;
  flex-grow: 1;
  flex: 1 auto;
  height: 100%;
  .tree-check-style {
    font-size: 14px;
    line-height: 20px;
    color: #555555;
  }
  .tree-content {
    overflow-y: auto;
    max-height: 651px;
    min-height: 651px;
    .MuiTreeItem-content {
      height: 48px;
      margin-top: 4px;
    }
    .MuiTreeItem-content .MuiTreeItem-label {
      font-size: 16px;
    }
  }
`;
export default SearchTreeStyled;
